import {LitElement, html, css} from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import store from '../src/store';
import { createReaction } from '../src/apiActions';
import { repeat } from 'lit/directives/repeat.js';
import { askToLogin } from '../src/store';
import { SldsBaseElement } from '../components/slds-base-element.js';

@customElement('post-actions')
class PostActions extends connect(store)(SldsBaseElement) {
  @property({type: Object}) item = null;
  @property({type: Boolean}) upvoted = false; //hasUpvoted
  @property({type: Number}) upvotes = 0;
  @property({type: Boolean}) downvoted = false; //hasDownvoted
  @property({type: Number}) downvotes = 0;
  @property({type: Boolean}) commentEnabled = false;
  @property({type: Boolean}) loggedIn = false;

  stateChanged(state) {
    if (state.user) {
      this.loggedIn = true;
    }
    else {
      this.loggedIn = false;
    }
  }

  updated(changedProperties) {
    if (changedProperties.has('item')) {
      if (!this.item) { return; }
      this.upvotes = this.item.upvotes;
      this.downvotes = this.item.downvotes;
      if (this.item.upvote) {
        this.upvoted = true;
      }
      if (this.item.downvote) {
        this.downvoted = true;
      }
    }
  }

  createEffect(e, isPositive = false) {
    const pos = {
      left: e.offsetLeft + 25,
      top: 30
    };
    // console.log(pos);
    const positiveElement = this.shadowRoot.getElementById('positive');
    const negativeElement = this.shadowRoot.getElementById('negative');
    const effects = [];
    for (var i = 15; i >= 0; i--) {
      var effect = null; //document.createElement("span");
      if (isPositive) {
        effect = positiveElement.cloneNode(true);
      }
      else
      {
        effect = negativeElement.cloneNode(true);
      }
      effect.removeAttribute('id');
      effect.classList.add("effect");
      effect.classList.remove('slds-hide');
      const randomSign = Math.random() < 0.5 ? -1 : 1;
      effect.style.left = pos.left + (randomSign*30*Math.random()) + "px";
      effect.style.top = pos.top + "px";
      if (isPositive) {
        effect.style.fill = "#0176D3";
      }
      else
      {
        effect.style.fill = "#BA0517";
      }
      effect.style.transform = "rotate("+(360*Math.random())+"deg)";
      effect.style.setProperty('--from-left', (pos.left + (100*Math.random()*randomSign)) + 'px');
      effect.style.setProperty('--from-top', (pos.top - (0.2+(0.5*Math.random()))) + 'px');
      effect.style.setProperty('--rotate-to', (360*Math.random())+'deg');
      effect.style.setProperty('--anim-speed', (0.85+(0.4*Math.random()))+'s');
      this.shadowRoot.getElementById("effects").appendChild(effect);
      effects.push(effect);
    }
    setTimeout(function() {
      for (var i = effects.length - 1; i >= 0; i--) {
        effects[i].remove();
      }
    }, 850);
  }

  static styles = [
    super.styles,
    css`
		:host {
      position: relative;
    }
    svg.effect {
      position: absolute;
      opacity: 0.9;
      animation: x var(--anim-speed) linear 1 alternate,
        y var(--anim-speed) 1 cubic-bezier(0.5,700,0.5,-700) alternate;
    }
    #effects>svg {
      cursor: pointer;
    }
    .post-buttons .slds-button_outline-brand {
      background-color: var(--background-color);
    }
    @keyframes x {
      to {
        left:var(--from-left);
        opacity: -0.3;
        transform: rotate(var(--rotate-to));
      }
    }
    @keyframes y {
      to {
        top:var(--from-top);
      }
    }
    `
  ];

  valToStr(val) {
    if (val === undefined || val === null) {
      return '';
    }
    const formattedVal = (val / 1000).toFixed(1);
    if (val<1000) {
      return val;
    }
    else
    {
      return (formattedVal.split(".").pop()==="0"?(val / 1000).toFixed(0):formattedVal) + 'k';
    }
  }

  upvote(url) {
    if (!this.loggedIn) {
      store.dispatch(askToLogin());
      return;
    }
    this.upvoted = !this.upvoted;
    if (this.downvoted) {
      this.downvotes = this.downvotes - 1;
      this.downvoted = false;
    }
    if (this.upvoted) {
      this.createEffect(this.shadowRoot.getElementById("upvote"), true);
    }
    if (this.upvoted) {
      this.upvotes = this.upvotes + 1;
    }
    else {
      this.upvotes = this.upvotes - 1;
    }
    store.dispatch(createReaction({
      url: url,
      type: 'upvote',
      upvoted: this.upvoted
    }));
  }

  downvote(url) {
    if (!this.loggedIn) {
      store.dispatch(askToLogin());
      return;
    }
    this.downvoted = !this.downvoted;
    if (this.upvoted) {
      this.upvotes = this.upvotes - 1;
      this.upvoted = false;
    }
    if (this.downvoted) {
      this.createEffect(this.shadowRoot.getElementById("downvote"), false);
    }
    if (this.downvoted) {
      this.downvotes = this.downvotes + 1;
    }
    else {
      this.downvotes = this.downvotes - 1;
    }
    store.dispatch(createReaction({
      url: url,
      type: 'downvote',
      downvoted: this.downvoted
    }));
    // Cancel this request if it fails
    // if (!this.downvoted) {
    //   this.downvotes = this.downvotes + 1;
    // }
    // else {
    //   this.downvotes = this.downvotes - 1;
    // }
    // this.downvoted = false;
  }

  openDialog(e) {
    e.preventDefault();
    this.dispatchEvent(new CustomEvent('dialog-opened', {detail: {id: this.item.url}}));
  }

  selectItem(e) {
    e.preventDefault();
    const href = e.target.closest('a').href;
    history.pushState({}, null, href);
    window.dispatchEvent(new CustomEvent('route'));
    this.requestUpdate();
  }

  render() {
    return html`
    <div class="${this.mobileMode ? 'slds-p-left_large slds-p-right_large' : ''}">
      <div class="slds-m-top_medium">
        ${
        this.item?.tags ? 
          html`
          <div class="slds-m-bottom_x-small post-tags">
            ${repeat(
                this.item.tags,
                (item) => html`<a class="slds-badge tag slds-m-bottom_x-small slds-text-heading_small" @click="${this.selectItem}" href="/tag/${item.slug}"><span>${item.tag}</span></a>`
            )}
          </div>
          ` : html``
        }
        </div>
        <div class="post-buttons slds-p-bottom_x-small">
          <button id="upvote" @click="${() => this.upvote(this.item?.url)}" class="slds-button ${this.upvoted?'slds-button_brand':'slds-button_outline-brand'} slds-text-heading_small slds-p-top_x-small slds-p-bottom_x-small">
            <svg class="slds-button__icon slds-button__icon_left slds-button__icon_large" aria-hidden="true">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#like"></use>
            </svg>${this.valToStr(this.upvotes)}</button>
          <button id="downvote" @click="${() => this.downvote(this.item?.url)}" class="slds-button ${this.downvoted?'slds-button_destructive':'slds-button_outline-brand'} slds-text-heading_small slds-p-top_x-small slds-p-bottom_x-small">
            <svg class="slds-button__icon slds-button__icon_left slds-button__icon_large" aria-hidden="true">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#dislike"></use>
            </svg>${this.valToStr(this.downvotes)}</button>
          ${this.commentEnabled ? html`<a @click="${this.openDialog}" href="/post/${this.item?.url}">
            <button class="slds-button ${(this.postOpen===this.item?.url)?'slds-button_brand':'slds-button_outline-brand'} slds-text-heading_small slds-p-top_x-small slds-p-bottom_x-small">
              <svg class="slds-button__icon slds-button__icon_left slds-button__icon_large" aria-hidden="true">
                <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#comments"></use>
              </svg>${this.valToStr(this.item?.comment_count)}</button>
          </a>` : html``}
        </div>
      </div>
      <div id="effects">
        <svg id="negative" class="slds-icon slds-icon-text-default slds-hide" aria-hidden="true"><use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#sentiment_negative"></use></svg>
        <svg id="positive" class="slds-icon slds-icon-text-default slds-hide" aria-hidden="true"><use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#smiley_and_people"></use></svg>
      </div>
    </div>
    `;
  }
}